import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { TOKEN_STORAGE_KEY } from '../views/admin/hooks/useToken';

export const client = new ApolloClient({
  link: from([
    setContext((_, { headers }) => {
      try {
        const rawToken = localStorage.getItem(TOKEN_STORAGE_KEY);
        const token = rawToken ? JSON.parse(rawToken) : null;

        if (rawToken) {
          return {
            headers: {
              ...headers,
              authorization: token ? `bearer ${token}` : undefined,
            },
          };
        }
      } catch (error: any) {
        console.warn(`Failed to get token: ${error.message}`);
      }

      return {};
    }),
    createHttpLink({
      uri: process.env.REACT_APP_GRAPHQL_ENDPOINT + '/graphql',
    }),
  ]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});
